import React, { forwardRef } from 'react';
import { number, object, oneOfType, string } from 'prop-types';

import stockService from '@services/stock';
import { cx } from '@emotion/css';

import { styStockIcon } from './style';

const StockIcon = forwardRef(({ code, className, size }, ref) => {
  const { data, isSuccess } = stockService.detail.about.useAbout(code);

  const getImgSrc = () => {
    if (!isSuccess) {
      return '';
    }

    return data?.icon_url;
  };

  const imgSrc = getImgSrc();

  return (
    <figure ref={ref} className={cx(styStockIcon({ size }), className)}>
      <img alt={`${code} icon`} src={imgSrc} />
    </figure>
  );
});

StockIcon.propTypes = {
  ref: object,
  code: string,
  className: string,
  size: oneOfType([string, number]),
};

StockIcon.defaultProps = {
  ref: null,
  code: '',
  className: '',
  size: 16,
};

export default StockIcon;
